module.exports = __webpack_public_path__ + "img/reliability.79f4b66.svg";